export default function getTypeName ( type ) {
    switch ( type ) {
        case 'pdf': return 'presentation'
        case 'video': return 'video'
        case 'audio': return 'audio'
        case 'youtube': return 'youtube'
        case 'vimeo': return 'vimeo'
        case 'wowza': return 'wowza'
        case 'scorm_cloud':
        case 'scorm': return 'scorm'
        case 'html': return 'html'
        case 'flash': return 'flash'
        case 'ppt': return 'powerpoint'
        case 'linkedin_slidshare': return 'slideshare'
        case 'conventional_test': return 'conventional_test'
        case 'block_test': return 'block_test'
        case 'restart_test': return 'restart_test'
        case 'evaluated_quiz': return 'evaluated_quiz'
        case 'unevaluated_quiz': return 'unevaluated_quiz'
        case 'block_general_test': return 'block_general_test'
        case 'restart_general_test': return 'restart_general_test'
        case 'reaction_evaluation': return 'reaction_evaluation'
        case 'webcast':
        case 'webinar': return 'webinar'
        case 'opened':
        case 'closed':
        case 'live_class_opened':
        case 'live_class_closed':
        case 'live_class': return 'live_class'
        case 'presential_event': return 'presential_event'
        case 'drag_and_drop': return 'drag_and_drop'
        case 'drag_the_words': return 'drag_the_words'
        case 'find_the_pairs': return 'find_the_pairs'
        case 'this_or_that': return 'this_or_that'
        case 'fill_in_the_blanks': return 'fill_in_the_blanks'
        case 'true_or_false': return 'true_or_false'
        case 'flashcards': return 'flashcards'
        case 'enigma': return 'enigma'

        default: return ''
    }
}
